module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企订单-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v(_vm._s(_vm.detailData.trans_bill_no) + "\n\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.detailData.bill_state == 10) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未处理\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 11) ? _c('span', {
    staticClass: "state-aqua-font"
  }, [_vm._v("待发货\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 12) ? _c('span', {
    staticClass: "state-orange-font"
  }, [_vm._v("已发货\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("已收货 待确认\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 14 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('span', {
    staticClass: "state-orange-font",
    staticStyle: {
      "background": "#70B603"
    }
  }, [_vm._v("已收货 已确认\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "bill-state-inter"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.detailData.weight_state == 0 && _vm.showDzcScaleappFlag) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未称重")]) : _vm._e(), _vm._v(" "), (_vm.detailData.weight_state == 1 && _vm.showDzcScaleappFlag) ? _c('span', {
    staticClass: "state-aqua-font"
  }, [_vm._v("待称重")]) : _vm._e(), _vm._v(" "), (_vm.detailData.weight_state == 2 && _vm.showDzcScaleappFlag) ? _c('span', {
    staticClass: "state-orange-font"
  }, [_vm._v("已称重")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billInfoShow),
      expression: "billInfoShow"
    }],
    staticClass: "bill-all-info"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("订货企业：" + _vm._s(_vm.detailData.restaurant_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t订货机构/时间：" + _vm._s(_vm.detailData.from_organ_name) + "\n\t\t\t\t\t"), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm._f("dateFilterYMD")(_vm.detailData.from_date)))])]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-to_organ_name"
  }, [(_vm.detailData.billBusTypeID !== '0450_0030_0600_3') ? _c('p', {
    staticClass: "to_organ_name-value"
  }, [_vm._v("收货机构/时间：" + _vm._s(_vm.detailData.to_organ_name))]) : _c('p', {
    staticClass: "to_organ_name-value"
  }, [_vm._v("门店名称/时间：" + _vm._s(_vm.detailData.to_organ_name))]), _vm._v(" "), _c('span', {
    staticClass: "to_date-value"
  }, [_vm._v(_vm._s(_vm._f("dateFilterYMD")(_vm.detailData.to_date)))])]), _vm._v(" "), (_vm.detailData.billBusTypeID === '0450_0030_0600') ? _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t发货时间：\n\t\t\t\t\t"), (_vm.editBillSendDate) ? _c('span', [_vm._v(_vm._s(_vm.detailData.sendDateStr) + "\n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billSendDate),
      expression: "billSendDate"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.billSendDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billSendDate = $event.target.value
      }
    }
  })]) : _c('span', [_vm._v(_vm._s(_vm.detailData.sendDateStr))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t收货人/联系方式：" + _vm._s(_vm.detailData.linkman) + "\n\t\t\t\t\t"), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.detailData.phone))])]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t收货地址：" + _vm._s(_vm.detailData.addr) + "\n\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("整单备注：" + _vm._s(_vm.detailData.remark))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_c('div', {
    staticClass: "detail-bill-delivery"
  }, [_vm._v("\n\t\t\t\t\t\t发货描述：" + _vm._s(_vm.detailData.delivery_describe) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-delivery"
  }, [_vm._v("快递服务商：" + _vm._s(_vm.detailData.express_provider))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-delivery"
  }, [_vm._v("快递单号：" + _vm._s(_vm.detailData.express_no))]), _vm._v(" "), (_vm.detailData.original_bill_id) ? _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-delivery"
  }, [_vm._v("第三方单号：" + _vm._s(_vm.detailData.original_bill_id))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "detail-search-input",
    attrs: {
      "placeholder": "请输入要搜索的品项名称"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [(_vm.uploadDeliverFlag !== undefined) ? _c('div', {
    staticClass: "upload-file-div"
  }, [_c('label', [_vm._v("附件资料：")]), _vm._v(" "), _c('upload-img', {
    attrs: {
      "uploadImgList": _vm.uploadImgList,
      "imgListLength": 10,
      "billState": _vm.detailData.bill_state,
      "jumpBill": _vm.jump_bill,
      "smallDelIco": _vm.smallDelIco
    },
    on: {
      "update:smallDelIco": function($event) {
        _vm.smallDelIco = $event
      },
      "attachDelPost": _vm.attachDelPost,
      "attachBeforeUpload": _vm.attachBeforeUpload,
      "attachClick": _vm.attachClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "detail-bill-address aqua-font"
  }, [_c('span', {
    staticClass: "list-btn fl",
    on: {
      "click": function($event) {
        return _vm.openBillListInfo()
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.billListInfoShow),
      expression: "!billListInfoShow"
    }],
    attrs: {
      "src": require("../assets/list_close.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billListInfoShow),
      expression: "billListInfoShow"
    }],
    attrs: {
      "src": require("../assets/list_open.png"),
      "alt": ""
    }
  })]), _vm._v("\n\t\t\t\t明细条目(" + _vm._s(_vm.detailsFilter.length) + ")\n\t\t\t\t"), ((_vm.billOtherData && _vm.billOtherData.isMiCunBanFan) && _vm.detailData.bill_state == 11 && !this.jump_bill) ? _c('router-link', {
    staticClass: "detail-bill-edit state-aqua-font",
    attrs: {
      "replace": "",
      "to": {
        path: '/detail-bill-edit',
        query: {
          bill_id: _vm.queryData.bill_id,
          searchWord: _vm.searchWord,
          send_date: _vm.billSendDate
        }
      }
    }
  }, [_vm._v("编辑")]) : (_vm.detailData.bill_state == 11 && !this.jump_bill) ? _c('router-link', {
    staticClass: "detail-bill-edit state-aqua-font",
    attrs: {
      "replace": "",
      "to": {
        path: '/detail-bill-edit',
        query: {
          bill_id: _vm.queryData.bill_id,
          searchWord: _vm.searchWord
        }
      }
    }
  }, [_vm._v("编辑")]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list width-full"
  }, _vm._l((_vm.detailsFilter), function(detail) {
    return _c('li', {
      staticClass: "width-full"
    }, [_c('ul', {
      staticClass: "detail-bill-sonlist width-full",
      class: !_vm.showItemCodeFlag && !_vm.showActualAssisNumFlag && !_vm.showActualNumFlag ? 'trisection-rows' : ''
    }, [_c('li', {
      staticClass: "detail-bill-fulllist detail-bill-list-title"
    }, [_c('w-img', {
      staticClass: "dlist-item-img",
      attrs: {
        "src": detail.goods_picture
      },
      on: {
        "on-click": function($event) {
          _vm.attachClick(detail.goods_picture ? (detail.goods_picture).replace(/\\/g, '/') : _vm.defaultImg)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dlist-item-img-span"
    }, [_vm._v(_vm._s(detail.goods_name)), ((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? _c('span', [_vm._v("(" + _vm._s(detail.goods_unit) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.detailData.billBusTypeID !== '0450_0030_0600_3') ? _c('span', {
      staticClass: "fr silvery-font dlist-item-img-span"
    }, [_vm._v(_vm._s(detail.inStoreName))]) : _c('span', {
      staticClass: "fr silvery-font dlist-item-img-span"
    }, [_vm._v(_vm._s(detail.inStoreName) + "/" + _vm._s(detail.shopStoreName))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!!detail.barcode),
        expression: "!!detail.barcode"
      }],
      staticClass: "qrc",
      on: {
        "click": function($event) {
          return _vm.barcodeClick(detail.barcode)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "25",
        "src": require("../assets/QRCode.jpg"),
        "alt": ""
      }
    })])], 1), _vm._v(" "), (detail.goods_code && _vm.showItemCodeFlag) ? _c('li', {
      staticClass: "detail-bill-fulllist"
    }, [_vm._v("品项编号：" + _vm._s(detail.goods_code))]) : _vm._e(), _vm._v(" "), (_vm.isPesc) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("规格：" + _vm._s(detail.goods_spec))]) : _vm._e(), _vm._v(" "), ((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("订货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num, 4)))]) : _vm._e(), _vm._v(" "), (detail.bill_gross_weight) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("毛重：" + _vm._s(_vm._f("numFixed")(detail.bill_gross_weight, 4)))]) : _vm._e(), _vm._v(" "), (((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) && _vm.showActualNumFlag) || _vm.isZ5) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("发货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_send, 4)))]) : _vm._e(), _vm._v(" "), (_vm.detailData.partial_delivery_flag === 1 && _vm.showActualNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("已发数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_sended, 4)))]) : _vm._e(), _vm._v(" "), (_vm.detailData.partial_delivery_flag === 1 && _vm.showActualNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("待发数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_wait_send, 4)))]) : _vm._e(), _vm._v(" "), (_vm.showMoneyFlag && !_vm.detailData.hiddenTax) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("价税合计：" + _vm._s(detail.sub_total_send) + " 元")]) : _vm._e(), _vm._v(" "), (_vm.showActualNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("实收数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_recipient, 4)))]) : _vm._e(), _vm._v(" "), (_vm.showMoneyFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("实收金额：" + _vm._s(detail.sub_total_recipient) + " 元")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (detail.goods_assist_unit),
        expression: "detail.goods_assist_unit"
      }]
    }, [(_vm.showActualAssisNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("辅助单位：" + _vm._s(detail.goods_assist_unit))]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("订货辅助数量：" + _vm._s(_vm._f("numFixed")(detail.goods_assist_num, 4)))]), _vm._v(" "), (_vm.showActualAssisNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("发货辅助数量：" + _vm._s(_vm._f("numFixed")(detail.goods_assist_num_send, 4)))]) : _vm._e(), _vm._v(" "), (_vm.showActualAssisNumFlag) ? _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("实收辅助数量：" + _vm._s(_vm._f("numFixed")(detail.goods_assist_num_recipient, 4)))]) : _vm._e()]), _vm._v(" "), (_vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('li', {
      staticClass: "detail-bill-twolist",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("差异数量：" + _vm._s(_vm._f("numFixed2")((detail.goods_num_send - detail.goods_num_recipient), 4)))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.billListInfoShow),
        expression: "billListInfoShow"
      }]
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailData.hiddenTax),
        expression: "!detailData.hiddenTax"
      }],
      staticClass: "detail-bill-twolist"
    }, [_vm._v("税率: " + _vm._s(detail.goods_cess) + " %")]), _vm._v(" "), _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("订货单价：" + _vm._s(detail.goods_price) + " 元")]), _vm._v(" "), _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailData.hiddenTax),
        expression: "!detailData.hiddenTax"
      }]
    }, [_vm._v("含税")]), _vm._v("(发货)单价：" + _vm._s(detail.goods_price_send) + " 元")]), _vm._v(" "), (!(detail.remark == null || detail.remark == '')) ? _c('li', {
      staticClass: "detail-bill-fulllist"
    }, [_vm._v("备注：" + _vm._s(detail.remark))]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('li', [_vm._v("收货单价：" + _vm._s(detail.goods_price_recipient) + " 元")]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('li', [_vm._v("收货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_recipient, 4)))]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('li', [_vm._v("收货金额：" + _vm._s(detail.sub_total_recipient) + " 元")]) : _vm._e()])])])
  }), 0)]), _vm._v(" "), (!_vm.detailsFilter.length) ? _c('div', {
    staticClass: "detail-bill-search-empty"
  }, [_c('div', {
    staticClass: "middle-empty"
  }), _vm._v(" "), _c('p', [_vm._v("未找到相关品项")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "detail-else-info"
  }, [(false) ? _c('p', [_vm._v("配送至：" + _vm._s(_vm.detailData.to_organ_name))]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 10 || _vm.detailData.bill_state == 11 || _vm.detailData.bill_state == 12 || _vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 14 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货金额：" + _vm._s(_vm._f("numFixed")(_vm.detailData.sum_money, _vm.numScale)) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsNum, 4)))])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 12 || _vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 14 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17 || (_vm.detailData.bill_state == 11 && _vm.detailData.partial_delivery_flag === 1 && _vm.isGoodsNumSendedZero === false)) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("发货金额：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsNumSendMoney, _vm.numScale)) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("发货数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsNumSend, 4)))])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13 || _vm.detailData.bill_state == 14 || _vm.detailData.bill_state == 15 || _vm.detailData.bill_state == 16 || _vm.detailData.bill_state == 17 || (_vm.detailData.bill_state == 11 && _vm.detailData.partial_delivery_flag === 1 && _vm.isGoodsNumSendedZero === false)) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("收货金额：" + _vm._s(_vm._f("numFixed")(_vm.detailData.sum_money_recipient, _vm.numScale)) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("收货数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsNumRecipient, 4)))])]) : _vm._e(), _vm._v(" "), (!_vm.isZ5) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNum, 4)))])]) : _vm._e(), _vm._v(" "), (!_vm.isZ5) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("发货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumSend, 4)))])]) : _vm._e(), _vm._v(" "), (!_vm.isZ5) ? _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("收货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumRecipient, 4)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-info"
  }, [_c('span', {
    staticClass: "detail-bill-total-btn",
    on: {
      "click": _vm.infoExchange
    }
  }, [_vm._v("合计")])]), _vm._v(" "), (_vm.detailData.bill_state == 10 && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.agreen(11)
      }
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 10 && _vm.refundFlag && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuse
    }
  }, [_vm._v("退回")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 11 && _vm.isGoodsNumSendedZero === true && _vm.refundFlag && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuse
    }
  }, [_vm._v("退回")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 11 && _vm.showDzcScaleappFlag) ? _c('div', {
    staticClass: "detail-bill-return detail-bill-retrun-bgOrange f-right",
    class: {
      'bgGrey': _vm.uploadImgList.length === 0 && _vm.uploadDeliverFlag && !_vm.isZ5
    }
  }, [_c('a', {
    on: {
      "click": _vm.onWeightMiniClick
    }
  }, [_vm._v("小程序称重")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 11 && !this.jump_bill) ? _c('more-bottons', {
    staticClass: "f-right",
    attrs: {
      "limitMoreButtons": 1
    }
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.detailData.bill_state == 11 && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-return f-right",
    class: {
      'bgGrey': ((_vm.uploadImgList.length === 0 && _vm.uploadDeliverFlag) || (_vm.expressNoDeliveryFlag && _vm.detailData.express_no === ''))
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.askSend(false)
      }
    }
  }, [_vm._v("发货")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 11 && _vm.detailData.partial_delivery_flag === 1 && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-return detail-bill-retrun-bgOrange f-right",
    class: {
      'bgGrey': _vm.uploadImgList.length === 0 && _vm.uploadDeliverFlag && !_vm.isZ5
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.askSend(true)
      }
    }
  }, [_vm._v("分批发货")])]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 12 && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": _vm.returnSend
    }
  }, [_vm._v("取消发货")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state != 10 && _vm.detailData.bill_state != 19 && !this.jump_bill && _vm.detailData.billBusTypeID !== '0400_0010_0200') ? _c('div', {
    staticClass: "detail-bill-return f-right",
    staticStyle: {
      "border-right": "solid 1px #fff"
    }
  }, [_c('a', {
    on: {
      "click": _vm.importExcel
    }
  }, [_vm._v("Excel")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.bill_state == 13 && !this.jump_bill) ? _c('div', {
    staticClass: "detail-bill-return f-right",
    staticStyle: {
      "border-right": "solid 1px #fff",
      "background-color": "#70B603"
    }
  }, [_c('a', {
    on: {
      "click": _vm.billStateConfirm
    }
  }, [_vm._v("确认")])]) : _vm._e()], 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont,
      "tipsFontWaring": _vm.tipsWaring
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsB),
      expression: "tipsB"
    }],
    attrs: {
      "btnNum": _vm.btnNumB,
      "tipsFont": _vm.tipsFont,
      "tipsFontWaring": _vm.tipsFontWaring
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), _c('tips-t', {
    ref: "tipsTShow",
    attrs: {
      "hasTipsFont": _vm.hasTipsFont,
      "btnFont": _vm.btnFont,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.getStatues,
      "onCancelTipStatus": _vm.cancelDel
    }
  }), _vm._v(" "), _c('item-img', {
    ref: "itemImgRef"
  }), _vm._v(" "), _c('barcode-img', {
    ref: "barcodeRef"
  }), _vm._v(" "), _c('fx-share', {
    model: {
      value: (_vm.copyPopShow),
      callback: function($$v) {
        _vm.copyPopShow = $$v
      },
      expression: "copyPopShow"
    }
  }, [_c('template', {
    slot: "mainContent"
  }, [_c('div', {
    staticClass: "order-item-block"
  }, [_c('div', {
    staticClass: "title-name"
  }, [_vm._v(_vm._s(_vm.detailData.to_organ_name) + " " + _vm._s(_vm._f("dateFilterYMD")(_vm.detailData.to_date)))]), _vm._v(" "), (_vm.detailData.linkman && _vm.detailData.phone) ? _c('div', {
    staticClass: "text-word"
  }, [_vm._v("收货人/联系方式：" + _vm._s(_vm.detailData.linkman) + " " + _vm._s(_vm.detailData.phone))]) : _vm._e(), _vm._v(" "), (_vm.detailData.addr) ? _c('div', {
    staticClass: "text-word"
  }, [_vm._v("收货地址：" + _vm._s(_vm.detailData.addr))]) : _vm._e(), _vm._v(" "), (_vm.detailData.remark && _vm.isZ5) ? _c('div', {
    staticClass: "text-word"
  }, [_vm._v("整单备注：" + _vm._s(_vm.detailData.remark))]) : _vm._e(), _vm._v(" "), (_vm.detailData.original_bill_id) ? _c('div', {
    staticClass: "text-word"
  }, [_vm._v("第三方单号：" + _vm._s(_vm.detailData.original_bill_id))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detailsFilter), function(good, index) {
    return _c('div', {
      staticClass: "item-row"
    }, [_c('div', {
      staticClass: "item-info"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(index + 1) + "、" + _vm._s(good.goods_name + ((_vm.showShareHouseFlag && good.inStoreName) ? '-' + good.inStoreName : '')) + "：\n\t\t\t\t\t\t" + _vm._s(((good.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? good.goods_num : good.goods_assist_num) + "\n\t\t\t\t\t\t" + _vm._s(((good.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? good.goods_unit : good.goods_assist_unit) + "\n\t\t\t\t\t\t" + _vm._s(good.goods_assist_unit && (_vm.showAssistUnitFlag && _vm.isZ5) ? ' 辅助：' + good.goods_assist_num + good.goods_assist_unit : '') + "\n\t\t\t\t\t")]), _vm._v(" "), (good.remark) ? _c('div', {
      staticClass: "item-remark"
    }, [_vm._v("备注：" + _vm._s(good.remark))]) : _vm._e()])
  })], 2)])], 2), _vm._v(" "), _c('side-float', {
    on: {
      "on-click": function($event) {
        _vm.copyPopShow = !_vm.copyPopShow
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b69a866!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DetailBill.vue
// module id = 575
// module chunks = 1